<template>
    <div class="content-container-white">

        <ModuleHeader title="Kunden editieren">
        </ModuleHeader>

        <div class="container">

        <div class="loading" v-if="!customer && !error">

        </div>

        <div v-if="error" class="error">
            <div class="mb-4">{{ error }}</div>
            <button type="button" class="btn btn-primary" @click="$router.go(-1)">Zurück</button>
        </div>

        <div v-if="saveError" class="error">
            <div class="mb-4">{{ saveError }}</div>
            <button type="button" class="btn btn-primary" @click="$router.go(-1)">Zurück</button>
        </div>

        <div v-if="customer && !saveError">
            <customer-form :onSaveCallback="updateCustomer" :editingCustomer="customer"/>
        </div></div>
    </div>
</template>

<script>
    import ModuleHeader from "components/util/ModuleHeader";
    import firestore from "firedb/init";
    import slugify from "slugify";
    import CustomerForm from "components/customer/CustomerForm";

    export default {
        name: "Edit",

        components: {ModuleHeader, CustomerForm},
        data: function() {
            return {
                customer: {},
                error: null,
                saveError: null
            }
        },
        created() {

            if (this.$route.params.slug) {

                //const ref = firestore.collection('customer').doc(this.$route.params.id);
                const ref = firestore.collection('customer').where('slug', '==', this.$route.params.slug);

                ref.get().then(snapshot => {

                    if (snapshot.empty) {
                        this.error = "Kunde konte nicht geladen werden";
                    } else {
                        snapshot.forEach(doc => {

                            this.customer = doc.data();
                            this.customer.id = doc.id;
                        });
                    }
                })
                    .catch(e => {
                        console.log(e);
                        this.error = "Kunde konte nicht geladen werden";
                    });
            }
        },
        methods: {

            updateCustomer() {

                //TODO object validation
                if (this.customer.name && this.customer.name.trim() !== '') {

                    firestore.collection('customer').doc(this.customer.id).update({
                        name: this.customer.name,
                        slug: slugify(this.customer.name, {
                            replacement: '-',
                            remove: /[$*_+~.()'"!\-:@#]/g,
                            lower: true
                        }),
                        vatId: this.customer.vatId || '',
                        street: this.customer.street || '',
                        city: this.customer.city || '',
                        zip: this.customer.zip || '',
                        contactPersons: this.customer.contactPersons || [],
                        vatReverseCharge: this.customer.vatReverseCharge,
                        country: this.customer.country
                    })
                    .then(result => {
                        this.$router.replace('/app/customer');
                    }).catch(e => {
                        console.error(e);
                        this.saveError = "Update konnte nicht ausgeführt werden."
                    });
                }
            },
        }
    }
</script>

<style scoped lang="scss">

    .buttons {
        margin-top: 2rem;
    }
</style>